/*global mod*/

mod.modules.define("BaseModule", function(fn) {

	var $window = null;
	var $documentBody = null;

	fn.prototype.init = function() {
		// Cache
		$window = $(window);
		$documentBody = $(document.body);

		// Init the tooltips
		this.el.find("a[rel=tooltip]").tooltip({
			maxWidth: 215
		});

		// Init any inputs with a default value
		this.el.find("input[placeholder]").defaultValue();
	};

	fn.prototype.handle_moduleExpand = function(id, extraContext) {
		extraContext = extraContext || {};

		var widgetId = "widget-" + id;

		// Create a wrapper for the modal
		var $modalWrapper = $("<div class='large-loader loading modal module-modal transparent' />").append(
			// Add a placeholder that will be replaced by the new widget
			$("<div class='loading-indicator' id='" + widgetId + "' />")).modal({
				backdrop: "static", // Prevent the modal from closing on blur
				show: false
			});
		
		$modalWrapper
			.off("show.bs.modal")
			.on("show.bs.modal", function () {
				// Reposition the modal
				var $modal = $(this);
				var currentTop = $modal.position().top;
				var windowTop = $window.scrollTop();
				var spacing = 100;
				$modal.css("top", currentTop + windowTop + spacing);

				$documentBody.addClass("covered");
			})
			.off("focusin.bs.modal")
			.on("focusin.bs.modal", function (e) {
				e.stopPropagation();
			})
			.off("hide.bs.modal")
			.on("hide.bs.modal", function () {
				$documentBody.removeClass("covered");

				// Remove the widget completely when the modal is closed
				var widgetClass = $("#" + widgetId).data("widget");

				if (widgetClass) {
					widgetClass.dispose(true);
				}

				$(this).remove();
			})
			.modal("show");
			

		// Load the new widget
		mod.modules.widgetapi.load({
			widgets: {
				appId: id,
				context: $.extend(true, {}, this.getContext(), extraContext)
			},
			success: function() {
				$modalWrapper.removeClass("loading");

			}
		});
	};

	fn.prototype.ajax_error = function(xhr) {
		// Throw the request onto the button so we can retry the call
		this.el.find("div.module-error button").data("xhr", xhr);
	};

	fn.prototype.events = {
		".module-error button": {
			"click": function(e, $el) {
				// Retry the last request
				var lastRequest = $el.data("xhr");

				if (lastRequest) {
					// Repeat the last request
					$.ajax(lastRequest);

					// Clear out the stored request
					$el.data("xhr", null);
				} else {
					this.reload();
				}
			}
		},
		// Change the size of the module
		".module-options [data-size]:not(.selected):not(.module-expand-link)": {
			"click": function(e, $el) {
				this.showLoading();

				var newSize = $el.attr("data-size");
				var type = this.el.attr("data-type");
				var newId = mod.modules.getKeyFromTypeSize(type, newSize);
				var context = this.getContext();

				mod.modules.widgetapi.load({
					widgets: {
						appId: newId,
						context: context
					},
					success: function() {
						mod.observer.trigger("module - resized");
					}
				});
			}
		},
		// Remove the module from the page
		".module-hide": {
			"click": function() {
				mod.observer.trigger("module - removed", this);
				this.dispose(true);
			}
		},
		".view-toggle": {
			"click": function(e, $el) {
				$("div[data-view]", $el.parents("div.module-content")).toggleClass("none");
				var text = $("span", $el).text();
				$("span", $el).text(text == "Show" ? "Hide" : "Show");
			}
		},
		// Show the expanded version of the module
		".module-expand-link": {
			"click": function (e, $el) {
				
				var newSize = 4;
				var type = this.el.attr("data-type");
				var newId = mod.modules.getKeyFromTypeSize(type, newSize);
				var context = $el.attr("data-context");

				if (context) {
					context = JSON.parse(context) || {};
				}

				this.handle_moduleExpand(newId, context);
			}
		},
		".action-download": {
			"click": function (e, $el) {
				$("#module_download").removeClass("hide");
			}
		},
		"#module_download .module-close": {
			"click": function (e, $el) {
				$("#module_download").addClass("hide");

				if (e.stopPropagation) {
					e.stopPropagation();
				}
					//IE8 and Lower
				else {
					e.cancelBubble = true;
				}
			}
		}
	};

});